import { Navigate, useParams } from "react-router-dom";
import { BinderEntryForm } from "../properties/BinderEntryForm.js";

export function BinderNew() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/app/properties" replace />;
  return <BinderEntryForm propertyId={id} mode="create" />;
}
